import { Team, User } from "../my-type";

const toNumber = (value: unknown): number | null => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim()) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const getTeamAdminUserUID = (team?: Team | null): number | null => {
  if (!team) {
    return null;
  }

  const rawTeam = team as Team & {
    adminUserUid?: unknown;
    AdminUserUID?: unknown;
    adminUserID?: unknown;
  };

  return (
    toNumber(rawTeam.adminUserUID) ??
    toNumber(rawTeam.adminUserUid) ??
    toNumber(rawTeam.AdminUserUID) ??
    toNumber(rawTeam.adminUserID)
  );
};

export const isTeamAdminUser = (user?: User | null): boolean => {
  const userId = toNumber(user?.id);
  const teamAdminUserUID = getTeamAdminUserUID(user?.team);

  return userId !== null && teamAdminUserUID !== null && userId === teamAdminUserUID;
};
